import { Container } from "../models/shipment.container";
import BaseService from "./_base.service";

const endpoint = "container/info";

const ShipmentContainerInfoService = {
  ...BaseService<Container>({ endpoint }),
};

export default ShipmentContainerInfoService;
